// domCache.js
const cache = {};

const mobileMQ = window.matchMedia('(max-width: 1024px)');

export function getEl(id) {
  if (!cache[id]) {
    cache[id] = document.getElementById(id);
  }
  return cache[id];
}

export function isMobile() {
  return mobileMQ.matches;
}

export function clearCache() {
  Object.keys(cache).forEach(k => delete cache[k]);
}

export function toggleLoading(loading) {
  // Disable / enable form fields
  document.querySelectorAll("form input, form select, button").forEach(
    (item) => {
      if (loading) {
        item.setAttribute('disabled', 'disabled');
      } else {
        item.removeAttribute('disabled');
      }
    }
  );

  getEl('loader').style.display = loading ? 'block' : 'none';
}

export function showError(message) {
  let errors = getEl('errors');
  let error = document.createElement('div');
  error.textContent = message;
  error.setAttribute('role', 'alert');
  errors.appendChild(error);
}

export function resetErrors() {
  let errors = getEl('errors');
  while (errors.firstChild) {
    errors.removeChild(errors.firstChild);
  }
}

export function invalidateFields(errors) {
  // Clear previous error states
  document.querySelectorAll('[aria-invalid="true"]').forEach(el => {
    el.removeAttribute('aria-invalid');
  });
  resetErrors();

  // Apply new ones
  Object.entries(errors).forEach(([field, message]) => {
    const el = getEl(field);
    if (!el) return;

    el.setAttribute('aria-invalid', 'true');
    if (message.length > 0) {
      showError(message);
    }
  });
}